<script>
  export default {
    name: "login",
    mounted() {
    }
  }
</script>
<style lang="scss" scoped>
  .main-section {
    padding: 6rem 0 3rem 0;
  }

  .card-body {
    padding: 3rem;
  }

  .avatar-register {
    width: 5rem;
    height: 5rem;
  }

  .icon-country {
    width: 1.5rem;
    height: 1.5rem;
  }

  .flex-shrink-0 {
    flex-shrink: 0 !important;
  }

  @media screen and (max-width: 480px) {
    .card-body {
      padding: 1.5rem;
    }
  }

  .form-text {
    color: #6c757d;
    transition: .3s ease-in-out;

    &:before {
      content: '\f00c';
      font-family: "Poppins", sans-serif;
      font-size: 1rem;
      margin-right: .5rem;
    }
  }
</style>

